module.exports = __webpack_public_path__ + "static/img/sexual_violence_2.0f75c427.png";